import {Component, OnDestroy, OnInit} from '@angular/core';
import {Params} from '@angular/router';
import {ReactiveFormsModule} from '@angular/forms';
import {Router} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {Observable, Subject, takeUntil} from 'rxjs';

import * as jose from 'jose';

import {ApiService, AppService} from 'shared/services';
import {ContentState} from 'shared/types';
import {SubmitState} from 'shared/interfaces';
import {ContentStatus} from 'shared/enums';
import {TokenUserModel} from 'shared/models';
import {SignInUiComponent} from './sing-in-ui/sign-in-ui.component';
import {AuthService} from './shared/services/auth.service';

@Component({
  selector: 'app-sign-in',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    SignInUiComponent
  ],
  templateUrl: './sign-in.component.html',
  styleUrl: './sign-in.component.scss',
  providers: [
    AuthService,
  ],
})
export class SignInComponent implements OnInit, OnDestroy {
  private unsubscribe = new Subject<void>();

  // @TODO
  private submitState$!: Observable<ContentState<SubmitState<Params>>>;

  constructor(
    private router: Router,
    private appService: AppService,
    private apiService: ApiService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.initStates();
    this.initSubscriptions();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private initStates() {
    this.submitState$ = this.authService.getSubmitState$(true);
  }

  private initSubscriptions() {
    this.submitState$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((state: ContentState<SubmitState<Params>>) => {
        if (state.status === ContentStatus.OK) {
          // this.appService.token = state.token;

          // Guarda la informacion de session en el LocalStorage
          // this.appService.saveSessionInfoToLocalStorage();

          console.info('auth', state);

          const token = (state?.value as Params)['token'];

          // const claims = jose.decodeJwt(state.value.token);
          const key = 'Dwka+p+QApjqBFAa2+ikJ6qwFtOu63+K5Tpk6PorUZ0=';
          // JWT.decrypt(token, key, {alg: 'EdDSA'}).then((foo) => {
          //   console.info('JWT.decrypt', foo);
          // });

          const claims = jose.decodeJwt(token);
          console.info('decodeJwt', claims);
          const tokenUser = TokenUserModel.getInstance(claims['data'] as Params);
          console.info('tokenUser', tokenUser);

          this.appService.login(token, tokenUser);

          // jose.jwtVerify(state.value.token, jose.EmbeddedJWK, {
          //   // issuer: 'urn:example:issuer',
          //   // audience: 'urn:example:audience',
          //   algorithms: ['EdDSA']
          // }).then((foo) => {
          //   console.info('JWT.jwtVerify', foo);
          // });

          // Redirecciona a la pagina de usuario
          this.router.navigate(['/']);
        }
      });
  }

  submit(data: Params) {
    // if (this.authForm.valid) {
    //   this.router.navigate(['/']);
    // } else {
    //   console.log('Form is invalid. Please check the fields.');
    // }
    console.info('submit', data);

    this.authService.submitSubject.next({
      observable$: this.apiService.save('auth', data)
        // .pipe(
        //   map((resData: Params): any => {
        //     return ViveroModel.getInstance(resData);
        //   }),
        //   map((model: MainModel) => {
        //     return {model};
        //   })
        // ),
    });
  }
}
